"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const get = (object, path, defaultValue = undefined) => {
    let requiredPath = path;
    let requiredObject = object;
    // Convert the path to an array if it's a string
    if (typeof requiredPath === 'string') {
        requiredPath = requiredPath.split(/[\.:]/g).filter(Boolean);
    }
    // Traverse the object using the path array
    for (const key of requiredPath) {
        if (requiredObject && typeof requiredObject === 'object' && key in requiredObject) {
            requiredObject = requiredObject[key];
        }
        else {
            return defaultValue;
        }
    } // Return the value or the default value if undefined
    return requiredObject !== undefined ? requiredObject : defaultValue;
};
exports.get = get;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3V0aWwvbG9kYXNoLWZ1bmN0aW9ucy9nZXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxHQUFHLEdBQUcsQ0FBQyxNQUFXLEVBQUUsSUFBdUIsRUFBRSxlQUFvQixTQUFTLEVBQU8sRUFBRTtJQUM1RixJQUFJLFlBQVksR0FBRyxJQUFJLENBQUM7SUFDeEIsSUFBSSxjQUFjLEdBQUcsTUFBTSxDQUFDO0lBRTVCLGdEQUFnRDtJQUNoRCxJQUFJLE9BQU8sWUFBWSxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQ25DLFlBQVksR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNoRSxDQUFDO0lBQ0QsMkNBQTJDO0lBQzNDLEtBQUssTUFBTSxHQUFHLElBQUksWUFBWSxFQUFFLENBQUM7UUFDN0IsSUFBSSxjQUFjLElBQUksT0FBTyxjQUFjLEtBQUssUUFBUSxJQUFJLEdBQUcsSUFBSSxjQUFjLEVBQUUsQ0FBQztZQUNoRixjQUFjLEdBQUcsY0FBYyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3pDLENBQUM7YUFBTSxDQUFDO1lBQ0osT0FBTyxZQUFZLENBQUM7UUFDeEIsQ0FBQztJQUNMLENBQUMsQ0FBQyxxREFBcUQ7SUFFdkQsT0FBTyxjQUFjLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQztBQUN4RSxDQUFDLENBQUM7QUFsQlcsUUFBQSxHQUFHLE9Ba0JkIn0=